import React, { useContext } from 'react';
import { Instagram, Mail } from 'lucide-react';
import { NavigationContext } from '../App';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/rrMcdWMWNCqHewjNXCcsn6/tmp_eb6d3570-1adb-41f6-bf95-edf1a21eebde.png';
export function Footer() {
  const {
    navigate
  } = useContext(NavigationContext);
  return <footer className="bg-[#5C3D2E] text-white pt-5 sm:pt-8 pb-4 sm:pb-4" data-id="element-114">
      {/* Kente stripe accent */}
      <div className="h-1.5 kente-stripe mb-5 sm:mb-6" data-id="element-115" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        {/* African Heritage Badge */}
        <div className="text-center mb-5 sm:mb-6" data-id="element-117">
          <p className="inline-flex items-center gap-3 text-[#D4A853] text-base sm:text-lg uppercase tracking-[0.2em] font-['Raleway']" data-id="element-118">
            <span className="w-10 sm:w-14 h-px bg-[#D4A853]/50" data-id="element-119" />
            For Africans, By an African
            <span className="w-10 sm:w-14 h-px bg-[#D4A853]/50" data-id="element-120" />
          </p>
        </div>

        {/* Mobile: Simplified single column */}
        <div className="sm:hidden text-center mb-4" data-id="element-121">
          <button onClick={() => navigate('home')} className="inline-block mb-1.5" data-id="element-122">
            <img src={LOGO_URL} alt="Christy Fashion Collection" className="h-[70px] w-auto object-contain mx-auto rounded-full bg-white p-1" data-id="element-123" />
          </button>

          <div className="flex justify-center gap-5 text-base text-white/70 font-['Raleway'] mb-2.5" data-id="element-124">
            <button onClick={() => navigate('shop')} className="hover:text-[#D4A853] transition-colors" data-id="element-125">
              Shop
            </button>
            <span className="text-white/20" data-id="element-126">·</span>
            <button onClick={() => navigate('about')} className="hover:text-[#D4A853] transition-colors" data-id="element-127">
              About
            </button>
            <span className="text-white/20" data-id="element-128">·</span>
            <button onClick={() => navigate('contact')} className="hover:text-[#D4A853] transition-colors" data-id="element-129">
              Contact
            </button>
          </div>

          <div className="flex justify-center gap-2.5 mb-2.5" data-id="element-130">
            <a href="mailto:christiana.nnanna@email.com" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4A853]/20 transition-colors" data-id="element-131">
              <Mail size={16} className="text-white/70" strokeWidth={1.5} data-id="element-132" />
            </a>
            <a href="https://instagram.com/christiana.nnanna" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4A853]/20 transition-colors" data-id="element-133">
              <Instagram size={16} className="text-white/70" strokeWidth={1.5} data-id="element-134" />
            </a>
          </div>

          <p className="text-sm text-white/50 font-['Raleway']" data-id="element-135">
            Zelle & CashApp · Ships across the U.S.
          </p>
        </div>

        {/* Desktop: Full grid layout */}
        <div className="hidden sm:grid sm:grid-cols-2 md:grid-cols-4 gap-5 lg:gap-6 mb-5" data-id="element-136">
          <div className="col-span-2 md:col-span-1" data-id="element-137">
            <button onClick={() => navigate('home')} className="block mb-1.5" data-id="element-138">
              <img src={LOGO_URL} alt="Christy Fashion Collection" className="h-[56px] w-auto object-contain rounded-full bg-white p-1" data-id="element-139" />
            </button>
            <p className="text-white/60 text-base leading-relaxed mb-2 font-['Raleway']" data-id="element-140">
              Celebrating African elegance with fashion that honors our
              heritage.
            </p>
            <a href="https://instagram.com/christiana.nnanna" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-base text-white/70 hover:text-[#D4A853] transition-colors font-['Raleway']" data-id="element-141">
              <Instagram size={16} strokeWidth={1.5} data-id="element-142" />
              @christiana.nnanna
            </a>
          </div>

          <div data-id="element-143">
            <h4 className="text-[#D4A853] text-sm uppercase tracking-[0.15em] font-semibold mb-2 font-['Raleway']" data-id="element-144">
              Quick Links
            </h4>
            <ul className="space-y-1 text-base text-white/70 font-['Raleway']" data-id="element-145">
              <li data-id="element-146">
                <button onClick={() => navigate('shop')} className="hover:text-[#D4A853] transition-colors" data-id="element-147">
                  Shop
                </button>
              </li>
              <li data-id="element-148">
                <button onClick={() => navigate('collections')} className="hover:text-[#D4A853] transition-colors" data-id="element-149">
                  Collections
                </button>
              </li>
              <li data-id="element-150">
                <button onClick={() => navigate('about')} className="hover:text-[#D4A853] transition-colors" data-id="element-151">
                  Our Story
                </button>
              </li>
              <li data-id="element-152">
                <button onClick={() => navigate('contact')} className="hover:text-[#D4A853] transition-colors" data-id="element-153">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-154">
            <h4 className="text-[#D4A853] text-sm uppercase tracking-[0.15em] font-semibold mb-2 font-['Raleway']" data-id="element-155">
              Shipping & Payment
            </h4>
            <ul className="space-y-1 text-base text-white/70 font-['Raleway']" data-id="element-156">
              <li data-id="element-157">Ships across the U.S.</li>
              <li data-id="element-158">
                <span className="text-white/50 text-sm uppercase tracking-wider" data-id="element-159">
                  Payment:
                </span>
                <br data-id="element-160" />
                Zelle & CashApp only
              </li>
            </ul>
          </div>

          <div data-id="element-161">
            <h4 className="text-[#D4A853] text-sm uppercase tracking-[0.15em] font-semibold mb-2 font-['Raleway']" data-id="element-162">
              Contact
            </h4>
            <ul className="space-y-1.5 text-base text-white/70 font-['Raleway']" data-id="element-163">
              <li data-id="element-164">
                <a href="mailto:christiana.nnanna@email.com" className="inline-flex items-center gap-1.5 hover:text-[#D4A853] transition-colors break-all" data-id="element-165">
                  <Mail size={16} strokeWidth={1.5} className="flex-shrink-0" data-id="element-166" />
                  christiana.nnanna@email.com
                </a>
              </li>
              <li data-id="element-167">
                <a href="https://instagram.com/christiana.nnanna" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-[#D4A853] transition-colors" data-id="element-168">
                  <Instagram size={16} strokeWidth={1.5} data-id="element-169" />
                  @christiana.nnanna
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-3" data-id="element-170">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-0.5" data-id="element-171">
            <p className="text-white/40 text-sm font-['Raleway']" data-id="element-172">
              © 2025 Christy Fashion Collection. All Rights Reserved.
            </p>
            <p className="text-white/40 text-sm font-['Raleway']" data-id="element-173">
              Powered by <span className="text-[#D4A853]" data-id="element-174">niishcloud</span>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}